<nav
  [hidden]="loading || _totalPageCount < 1"
  class="card navbar navbar-light bg-faded m-b-30 p-10"
  [ngClass]="{ 'make-transparent': !showNavBar }"
  ng-click="$event.stopPropagation()"
>
  <div>
    <!-- Prev btn -->
    <i
      [hidden]="_currentPage === 1"
      class="icofont icofont-circled-left btn btn-primary"
      [ngClass]="{ 'btn-sm': smallButtons }"
      id="btn-click-previous-pg"
      (click)="broadCastPageButton($event)"
    >
      &nbsp;Prev
    </i>

    <!-- Current pg btn -->
    <button
      class="btn btn-success current-page-button"
      [ngClass]="{ 'btn-sm': smallButtons }"
    >
      &nbsp;Pg&nbsp;{{ _currentPage }} of {{ _totalPageCount }}&nbsp;
    </button>

    <!-- Next btn -->
    <i
      [hidden]="_currentPage >= _totalPageCount"
      id="btn-click-next-pg"
      (click)="broadCastPageButton($event)"
      class="icofont icofont-circled-right btn btn-primary"
      [ngClass]="{ 'btn-sm': smallButtons }"
    >
      &nbsp;Next
    </i>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</nav>
